import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const InnerWrapper = styled(Flex)`
  flex-wrap: wrap;
  max-width: 100vw;
  margin: 0 auto;
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  justify-content: center;
  align-content: center;

  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      max-width: 820px;
    }
  `};
`;
